import Binds from './Binds.js';
export default Binds;
